import { ViewController } from '@estee/elc-service';
import { action, observable } from 'mobx';

export class ShadeFiltersViewController extends ViewController {
    @observable public isFiltersModalOpen: boolean = false;

    @action
    public onOpenFiltersClick = () => {
        this.isFiltersModalOpen = true;
    };

    @action
    public onCloseFiltersClick = () => {
        this.isFiltersModalOpen = false;
    };

    public toggleFilters = () => {
        this.isFiltersModalOpen ? this.onCloseFiltersClick() : this.onOpenFiltersClick();
    };
}
